import React from 'react';

import './Page.scss';

function Page(props) {
    return (
        <div
            className="main-page"
            aria-label="Main"
        >
            {props.children}
        </div>
    );
}

export default Page;
